import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxZeroStateModule } from '@go-modules/components/zero-state/zero-state.module';
import { SessionZeroStateComponent } from './session-zero-state.component';
import { GoMaterialModule } from '@go-modules/go-material.module';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		NgxZeroStateModule
	],
	declarations: [
		SessionZeroStateComponent
	],
	exports: [
		SessionZeroStateComponent
	]
})
export class SessionZeroStateModule {}
